import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { HarlequinAddressCardStackContentViewModel } from './harlequin-address-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-harlequin-address-card-stack-content',
  templateUrl: './harlequin-address-card-stack-content.component.html',
  styleUrls: ['./harlequin-address-card-stack-content.component.scss'],
  providers: [HarlequinAddressCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HarlequinAddressCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public viewModel: HarlequinAddressCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
